export const pixelTheme = {
  colors: {
    primary: '#6366F1',      // Bright Indigo
    secondary: '#4338CA',    // Deep Indigo
    accent: '#F59E0B',       // Amber/Orange
    success: '#10B981',      // Emerald Green
    danger: '#EF4444',       // Red
    dark: '#1F2937',         // Dark Gray
    darker: '#111827',       // Darker Gray
    light: '#F8FAFC',        // Very Light Gray
    text: '#111827',         // Very Dark Gray text
    textSecondary: '#6B7280', // Medium Gray text
    background: '#FFFFFF',    // White background
    backgroundLight: '#F1F5F9', // Light Gray background
    border: '#E2E8F0',       // Light Gray border
    shadow: 'rgba(99, 102, 241, 0.2)',
  },
  fonts: {
    pixel: '"Pixelify Sans", monospace',
    secondary: '"Pixelify Sans", monospace',
    body: '"Pixelify Sans", monospace',
  },
  pixelSizes: {
    tiny: '8px',
    small: '12px',
    medium: '16px',
    large: '24px',
    huge: '32px',
  },
  animations: {
    blink: `
      @keyframes blink {
        0%, 50% { opacity: 1; }
        51%, 100% { opacity: 0; }
      }
    `,
    float: `
      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-10px); }
      }
    `,
    pulse: `
      @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
      }
    `,
    glitch: `
      @keyframes glitch {
        0%, 100% { 
          text-shadow: 
            2px 0 #FFD700,
            -2px 0 #8B5FBF;
        }
        25% { 
          text-shadow: 
            -2px 0 #FFD700,
            2px 0 #8B5FBF;
        }
        50% { 
          text-shadow: 
            2px 2px #FFD700,
            -2px -2px #8B5FBF;
        }
        75% { 
          text-shadow: 
            -2px 2px #FFD700,
            2px -2px #8B5FBF;
        }
      }
    `,
  },
  effects: {
    pixelBorder: (color = '#6B46C1', size = '2px') => `
      border: ${size} solid ${color};
      box-shadow: 
        inset -${size} -${size} 0 0 rgba(0,0,0,0.3),
        inset ${size} ${size} 0 0 rgba(255,255,255,0.2);
    `,
    textShadow: (color = '#8B5FBF') => `
      text-shadow: 
        2px 2px 0 ${color},
        4px 4px 0 rgba(0,0,0,0.5);
    `,
    glowEffect: (color = '#FFD700') => `
      text-shadow: 
        0 0 5px ${color},
        0 0 10px ${color},
        0 0 15px ${color};
    `,
  },
};